import React from "react";
import ContentContainer from "../../components/container/ContentContainer";
import ContactExpert from "../../components/controls/ContactExpert";
import Header from "../../components/sections/Header";
import HeadData from "../../data/HeadData";
import TitleDiv from "../../components/controls/TitleDiv";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import Layout from "../../components/layout/Layout";

const ProductsPage = () => {
  const path = ["Products"];

  const products = [
    {
      title: "Hardwood Lumber",
      supplier: "Various Suppliers",
      image: (
        <StaticImage
          src="../../images/hardwood-lumber-product.png"
          alt="Hardwood Lumber"
          placeholder="blurred"
          quality={100}
          className="h-60"
        />
      ),
      link: "./hardwood-lumber",
    },
    {
      title: "Hardwood Plywood",
      supplier: "Various Suppliers",
      image: (
        <StaticImage
          src="../../images/hardwood-plywood-product.png"
          alt="Hardwood Plywood"
          placeholder="blurred"
          quality={100}
          className="h-60"
        />
      ),
      link: "./hardwood-plywood",
    },
    {
      title: "Lacquered Panels",
      supplier: "OneSkin",
      image: (
        <StaticImage
          src="../../images/oneskin-related-section.png"
          alt="Lacquered Panels"
          placeholder="blurred"
          quality={100}
          className="h-60"
        />
      ),
      link: "./lacquered-boards",
    },
    {
      title: "European Thermofused Laminates",
      supplier: "Emporio Skin",
      image: (
        <StaticImage
          src="../../images/emporio-skin-section.png"
          alt="Thermofused Laminates"
          placeholder="blurred"
          quality={100}
          className="h-60"
        />
      ),
      link: "./thermofused-laminates",
    },
    {
      title: "Thermally Fused Laminates",
      supplier: "Arauco",
      image: (
        <StaticImage
          src="../../images/Arauco-featured-section.jpg"
          alt="Melamine"
          placeholder="blurred"
          quality={100}
          className="h-60"
        />
      ),
      link: "./thermally-fused-laminates",
    },
    {
      title: "MDF",
      supplier: "Various Suppliers",
      image: (
        <StaticImage
          src="../../images/mdf-product.png"
          alt="MDF"
          placeholder="blurred"
          quality={100}
          className="h-60"
        />
      ),
      link: "./mdf",
    },
    {
      title: "Ridgemont Pre-finished Wood Panels",
      supplier: "States Industries",
      image: (
        <StaticImage
          src="../../images/ridgemont-panels-section-1.png"
          alt="Pre-finished Wood Panels"
          placeholder="blurred"
          quality={100}
          className="h-60"
        />
      ),
      link: "./pre-finished-wood-panels",
    },
    {
      title: "Thermally Modified Wood (For Decking & Siding)",
      supplier: "Lunawood",
      image: (
        <StaticImage
          src="../../images/thermally-modified-wood-products-with-credit-2.png"
          alt="Thermally Modified Wood"
          placeholder="blurred"
          objectPosition="center bottom"
          quality={100}
          className="h-60"
        />
      ),
      link: "./thermally-modified-wood",
    }
  ];

  const ProductGallery = ({ title, supplier, image, link }) => {
    return (
      <Link to={link ? link : "."}>
        <div className="flex flex-col text-center text-white text-xl">
          <h2 className="bg-actionBlue text-xl tracking-normal normal-case font-normal font-archivo text-center p-3">{title}<br/>by {supplier}</h2>
          {image}
        </div>
      </Link>
    );
  };
  
  return (
    <Layout>
      <div className="w-full max-w-full relative overflow-hidden">
        <HeadData title="Products" />
        <Header />

        <TitleDiv title="Products" className="mb-1" path={path} />

        <ContentContainer
          className="w-full max-w-screen-lg mt-10 lg:mt-28 bg-center grid grid-cols-1 md:grid-cols-2 gap-9 mb-10"
          opacityClassName="bg-opacity-60"
        >
          {products.map((product, index) => {
            return (
              <ProductGallery
                key={`productGallery${index}`}
                title={product.title}
                supplier={product.supplier}
                image={product.image}
                link={product.link}
              />
            );
          })}
        </ContentContainer>

        <ContactExpert />
      </div>
    </Layout>
  );
};

export default ProductsPage;
